import { URLS } from "@/constants/constants";
import { response } from "@/types";
import { signOut } from "next-auth/react";

export async function getUserDetails<T>(): Promise<response<T>> {
  try {
    const response = await fetch("/api/get-user-details", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const result = await response.json();

    if (response.ok && result.success) {
      return { success: true, data: result.data };
    } else {
      if (result.message === "User not found") {
        await signOut({ callbackUrl: URLS.LOGOUT });
      }
      return { success: false, error: result.error || "Unknown error" };
    }
  } catch (error) {
    return { success: false, error: `Failed to get data: ${error}` };
  }
}
